module.exports = __webpack_public_path__ + "img/thumbnail_CommonWombat_f_normal.41d28443.png";